export default __webpack_public_path__ + "static/media/logo-light.a1799653.svg";